import { c as _c } from "react/compiler-runtime";
import { ThirdPartyScriptWrapper } from './ThirdPartyScriptWrapper';

// 'afterInteractive' for above-the-fold forms (hero); 'lazyOnload' for forms further down the page
type MarketoFormsStrategy = 'afterInteractive' | 'lazyOnload';
export const MarketoForms2 = t0 => {
  const $ = _c(2);
  const {
    strategy: t1
  } = t0;
  const strategy = t1 === undefined ? "lazyOnload" : t1;
  let t2;
  if ($[0] !== strategy) {
    t2 = <ThirdPartyScriptWrapper id="marketo-forms2" scriptContent="" ignoreInDevelopment={false} scriptOptions={{
      src: "https://learn.lokalise.com/js/forms2/js/forms2.min.js",
      defer: true,
      strategy
    }} />;
    $[0] = strategy;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
};